import { IPageSchema } from '../repositories/chats/entities/synchronization/PageSchema';
import {
  fetchGetSubAgentsDesktop,
  IGetSubAgentsDesktopRequest,
  TGetSubAgentsDesktopResponse,
} from '../repositories/chats/v1/get-sub-agents-desktop';
import { ERequestApiStatus } from '../types/appState';
import { TContext } from '../types/context';
import { EExceptionDomain } from '../types/exceptionDomains';
import { TUser } from '../types/userData';
import { getSubAgentsFetchLimit } from '../utils/getSubAgentsFetchLimit';
import { isSubAgentsChatsEnabled as _isSubAgentsChatsEnabled } from '../utils/isSubAgentsChatsEnabled';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

type TFetchSubAgentsParams = {
  parameters?: { offset?: number; search?: string };
  cookies?: string;
  user: TUser;
};

const DEFAULT_ERROR_MESSAGE = 'Ошибка при получении списка сотрудников';

export async function fetchSubAgents(
  { logger, httpApi, config }: TContext,
  { cookies, parameters, user }: TFetchSubAgentsParams,
) {
  const isSubAgentsChatsEnabled = _isSubAgentsChatsEnabled(config);

  if (!user.isAuthenticated || user.agentAccountType !== 'agency' || !isSubAgentsChatsEnabled) {
    return { status: ERequestApiStatus.Initial, subAgentsList: [], page: {} as IPageSchema };
  }

  const limit = getSubAgentsFetchLimit(config);

  const requestParameters: IGetSubAgentsDesktopRequest = {
    limit,
    offset: parameters?.offset ?? 0,
    search: parameters?.search,
  };

  try {
    const { response, statusCode }: TGetSubAgentsDesktopResponse = await fetchGetSubAgentsDesktop({
      httpApi,
      parameters: requestParameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.SubAgents,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return { page: response.page, subAgentsList: response.subAgents, status: ERequestApiStatus.Succeed };
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.SubAgents,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/get-sub-agents-desktop/',
      parameters: JSON.stringify(requestParameters),
    });

    return;
  }
}
